.band {
  position: relative;
  display: flex;
  align-items: center;
  gap: var(--dimension-space-3);
  padding: var(--dimension-space-1) var(--dimension-space-3) calc(var(--dimension-space-1) + 4px);
  background: var(--color-surface-inverse);
  color: var(--color-text-on-inverse);
}
.time {
  flex: 1;
}
.speed {
  color: var(--color-text-on-inverse);
}
.link {
  color: var(--color-text-on-inverse);
}
.stripes {
  position: absolute;
  inset: auto 0 0;
  height: 4px;
}
